'use strict';

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var delay = require('yoctodelay');

var pMinDelay = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(promise, minimumDelay, options) {
    var promiseError, _yield$Promise$all, _yield$Promise$all2, value;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _objectSpread({
              delayRejection: true
            }, options);

            if (options.delayRejection) {
              promise = promise.catch(function (error) {
                promiseError = error;
              });
            }

            _context.next = 4;
            return Promise.all([promise, delay(minimumDelay)]);

          case 4:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 1);
            value = _yield$Promise$all2[0];
            return _context.abrupt("return", promiseError ? Promise.reject(promiseError) : value);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function pMinDelay(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

module.exports = pMinDelay; // TODO: Remove this for the next major release

module.exports.default = pMinDelay;